import { localDatabaseUrls } from "../backend/constants";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { putAPI } from "../backend/commons";

const normalizeDecimalValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }

  const normalized = Number(String(value).replace(/,/g, ""));
  return Number.isFinite(normalized) ? normalized : null;
};

const resolveBatchId = (row) => row?.batchId ?? row?.batch_id ?? row?.batchid ?? "";

const resolveParsedSku = (row) =>
  row?.parsedSku ?? row?.parsed_sku ?? row?.napaSku ?? row?.napa_sku ?? "";

const resolveHqLine = (row) => row?.hqLine ?? row?.hq_line ?? "";

const resolveOldLandedCost = (row) =>
  normalizeDecimalValue(row?.oldLandedCost ?? row?.old_landed_cost);

const resolveEditNewLandedCost = (row) =>
  normalizeDecimalValue(
    row?.editNewLandedCost ??
      row?.edit_new_landed_cost ??
      row?.newLandedCost ??
      row?.new_landed_cost
  );

const resolveNewLandedCost = (row) =>
  normalizeDecimalValue(row?.newLandedCost ?? row?.new_landed_cost ?? row?.editNewLandedCost ?? row?.edit_new_landed_cost);

const resolveUpdateBy = (row, fallbackUpdateBy) => {
  const updateBy = row?.updateBy ?? row?.update_by;
  if (updateBy !== undefined && updateBy !== null && String(updateBy).trim() !== "") {
    return updateBy;
  }

  return fallbackUpdateBy ?? "";
};

const resolveUserEmail = (tokenInfo = {}) => tokenInfo.username ?? tokenInfo.email ?? "";

const buildEditPayload = (rows, updateBy) =>
  JSON.stringify(
    rows.map((row) => ({
      batchId: resolveBatchId(row),
      parsedSku: resolveParsedSku(row),
      hqLine: resolveHqLine(row),
      oldLandedCost: resolveOldLandedCost(row),
      editNewLandedCost: resolveEditNewLandedCost(row),
      newLandedCost: resolveNewLandedCost(row),
      updateBy: resolveUpdateBy(row, updateBy),
    }))
  );

const buildApprovalPayload = (rows, approved, approvedBy) =>
  JSON.stringify(
    rows.map((row) => ({
      batchId: resolveBatchId(row),
      parsedSku: resolveParsedSku(row),
      hqLine: resolveHqLine(row),
      approved,
      approvedBy: approvedBy ?? "",
    }))
  );

export const updateLandedCostItemWorkflow = async (rows = [], options = {}) => {
  if (!Array.isArray(rows) || !rows.length) {
    return null;
  }

  const tokenInfo = await getJWTToken();
  if (!tokenInfo) {
    window.location.href = "/";
    return null;
  }

  const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.landedCostUpdate}`;
  const userEmail = resolveUserEmail(tokenInfo);
  const payload = options?.approved
    ? buildApprovalPayload(rows, options.approved, userEmail)
    : buildEditPayload(rows, userEmail);

  return putAPI(apiUrl, tokenInfo, payload);
};

export default updateLandedCostItemWorkflow;
